/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * SSO configuration
 * @export
 * @interface SsoConfigRequest
 */
export interface SsoConfigRequest {
    /**
     * Domain to configure SSO for
     * @type {string}
     * @memberof SsoConfigRequest
     */
    domain: string;
    /**
     * SSO provider type
     * @type {string}
     * @memberof SsoConfigRequest
     */
    providerType: SsoConfigRequestProviderTypeEnum;
    /**
     * Azure AD tenant ID (required for Azure AD)
     * @type {string}
     * @memberof SsoConfigRequest
     */
    tenantId?: string;
    /**
     * Azure AD client ID (required when using your own app registration, ignored when useEnterpriseApp=true)
     * @type {string}
     * @memberof SsoConfigRequest
     */
    clientId?: string;
    /**
     * Azure AD client secret (required when using your own app registration, ignored when useEnterpriseApp=true)
     * @type {string}
     * @memberof SsoConfigRequest
     */
    clientSecret?: string;
    /**
     * Whether to use enterprise application (if available) instead of customer's own app registration. If true and enterprise app is available, clientId/clientSecret are ignored. If false or null, customer's own app registration credentials are required.
     * @type {boolean}
     * @memberof SsoConfigRequest
     */
    useEnterpriseApp?: boolean;
    /**
     * Enterprise App configuration ID (required when useEnterpriseApp=true to specify which Enterprise App configuration to use). Must be provided when useEnterpriseApp=true.
     * @type {string}
     * @memberof SsoConfigRequest
     */
    enterpriseAppId: string;
    /**
     * Azure cloud/environment (optional, defaults to 'com' for Public)
     * @type {string}
     * @memberof SsoConfigRequest
     */
    cloud?: SsoConfigRequestCloudEnum;
    /**
     * Okta domain (required for Okta)
     * @type {string}
     * @memberof SsoConfigRequest
     */
    oktaDomain?: string;
    /**
     * Google hosted domain (required for Google)
     * @type {string}
     * @memberof SsoConfigRequest
     */
    hostedDomain?: string;
    /**
     * SAML entity ID (required for SAML)
     * @type {string}
     * @memberof SsoConfigRequest
     */
    entityId?: string;
    /**
     * SAML SSO service URL (required for SAML)
     * @type {string}
     * @memberof SsoConfigRequest
     */
    singleSignOnServiceUrl?: string;
    /**
     * SAML X.509 certificate (required for SAML)
     * @type {string}
     * @memberof SsoConfigRequest
     */
    x509Certificate?: string;
    /**
     * OIDC issuer URL (required for custom OIDC)
     * @type {string}
     * @memberof SsoConfigRequest
     */
    issuer?: string;
    /**
     * Custom OIDC authorization URL (optional)
     * @type {string}
     * @memberof SsoConfigRequest
     */
    authorizationUrl?: string;
    /**
     * Custom OIDC token URL (optional)
     * @type {string}
     * @memberof SsoConfigRequest
     */
    tokenUrl?: string;
    /**
     * Custom OIDC user info URL (optional)
     * @type {string}
     * @memberof SsoConfigRequest
     */
    userInfoUrl?: string;
    /**
     * Custom OIDC logout URL (optional)
     * @type {string}
     * @memberof SsoConfigRequest
     */
    logoutUrl?: string;
    /**
     * Custom claim mappings for OIDC (optional)
     * @type {{ [key: string]: string; }}
     * @memberof SsoConfigRequest
     */
    customClaims?: { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof SsoConfigRequest
     */
    valid?: boolean;
}


/**
 * @export
 */
export const SsoConfigRequestProviderTypeEnum = {
    Azure: 'azure',
    Okta: 'okta',
    Google: 'google',
    Saml: 'saml',
    Oidc: 'oidc'
} as const;
export type SsoConfigRequestProviderTypeEnum = typeof SsoConfigRequestProviderTypeEnum[keyof typeof SsoConfigRequestProviderTypeEnum];

/**
 * @export
 */
export const SsoConfigRequestCloudEnum = {
    Com: 'com',
    Us: 'us',
    Cn: 'cn',
    De: 'de'
} as const;
export type SsoConfigRequestCloudEnum = typeof SsoConfigRequestCloudEnum[keyof typeof SsoConfigRequestCloudEnum];


/**
 * Check if a given object implements the SsoConfigRequest interface.
 */
export function instanceOfSsoConfigRequest(value: object): value is SsoConfigRequest {
    if (!('domain' in value) || value['domain'] === undefined) return false;
    if (!('providerType' in value) || value['providerType'] === undefined) return false;
    if (!('enterpriseAppId' in value) || value['enterpriseAppId'] === undefined) return false;
    return true;
}

export function SsoConfigRequestFromJSON(json: any): SsoConfigRequest {
    return SsoConfigRequestFromJSONTyped(json, false);
}

export function SsoConfigRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SsoConfigRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'domain': json['domain'],
        'providerType': json['providerType'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'clientId': json['clientId'] == null ? undefined : json['clientId'],
        'clientSecret': json['clientSecret'] == null ? undefined : json['clientSecret'],
        'useEnterpriseApp': json['useEnterpriseApp'] == null ? undefined : json['useEnterpriseApp'],
        'enterpriseAppId': json['enterpriseAppId'],
        'cloud': json['cloud'] == null ? undefined : json['cloud'],
        'oktaDomain': json['oktaDomain'] == null ? undefined : json['oktaDomain'],
        'hostedDomain': json['hostedDomain'] == null ? undefined : json['hostedDomain'],
        'entityId': json['entityId'] == null ? undefined : json['entityId'],
        'singleSignOnServiceUrl': json['singleSignOnServiceUrl'] == null ? undefined : json['singleSignOnServiceUrl'],
        'x509Certificate': json['x509Certificate'] == null ? undefined : json['x509Certificate'],
        'issuer': json['issuer'] == null ? undefined : json['issuer'],
        'authorizationUrl': json['authorizationUrl'] == null ? undefined : json['authorizationUrl'],
        'tokenUrl': json['tokenUrl'] == null ? undefined : json['tokenUrl'],
        'userInfoUrl': json['userInfoUrl'] == null ? undefined : json['userInfoUrl'],
        'logoutUrl': json['logoutUrl'] == null ? undefined : json['logoutUrl'],
        'customClaims': json['customClaims'] == null ? undefined : json['customClaims'],
        'valid': json['valid'] == null ? undefined : json['valid'],
    };
}

export function SsoConfigRequestToJSON(json: any): SsoConfigRequest {
    return SsoConfigRequestToJSONTyped(json, false);
}

export function SsoConfigRequestToJSONTyped(value?: SsoConfigRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'domain': value['domain'],
        'providerType': value['providerType'],
        'tenantId': value['tenantId'],
        'clientId': value['clientId'],
        'clientSecret': value['clientSecret'],
        'useEnterpriseApp': value['useEnterpriseApp'],
        'enterpriseAppId': value['enterpriseAppId'],
        'cloud': value['cloud'],
        'oktaDomain': value['oktaDomain'],
        'hostedDomain': value['hostedDomain'],
        'entityId': value['entityId'],
        'singleSignOnServiceUrl': value['singleSignOnServiceUrl'],
        'x509Certificate': value['x509Certificate'],
        'issuer': value['issuer'],
        'authorizationUrl': value['authorizationUrl'],
        'tokenUrl': value['tokenUrl'],
        'userInfoUrl': value['userInfoUrl'],
        'logoutUrl': value['logoutUrl'],
        'customClaims': value['customClaims'],
        'valid': value['valid'],
    };
}

